import { useTranslation } from "react-i18next";
import { History } from "components/History/History";
import { ExportToCsv } from "export-to-csv";
import { useMutation } from "@tanstack/react-query";
import { exportHistory } from "../../pages/HistoryPage/HistoryPage.api";
import { useAuth } from "context/auth-context";
import { toast } from "react-toastify";
import { FiDownload } from "react-icons/fi";
import { Card } from "components/ui";

export const Shistory = () => {
  const { t } = useTranslation();
  const { auth } = useAuth();

  const mutation = useMutation(() => exportHistory(auth?.panelistId), {
    onSuccess: (data) => {
      if (data?.success && Array.isArray(data?.data) && data.data.length > 0) {
        const options = {
          fieldSeparator: ",",
          quoteStrings: '"',
          decimalSeparator: ".",
          showLabels: true,
          showTitle: false,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          title: "Survey_History_Report",
          filename: "Survey_History_Report", 
        };
        const csvExporter = new ExportToCsv(options);
        const csvData = data.data.map((e) => ({
          surveyName: e.surveyName,
          points: e.points,
          createdAt: e.createdAt,
          status: e.status
        }));
        csvExporter.generateCsv(csvData);
      } else {
        toast.error(t("surveyHistory.download.errorMessage"));
      }
    },
  });

  return (
    <Card
      title={t("histortpage.surveyHistory")}
      flush
      actions={
        <button data-testid="button" onClick={() => mutation.mutate()} className="zs-btn zs-btn-secondary zs-btn-sm">
          <FiDownload />
          <span>{t("page.history.SurveyHistory")}</span>
        </button>
      }
    >
      <div data-testid="survey" className="flex flex-col w-full">
        <History />
      </div>
    </Card>
  );
};